"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.NodeTypeSchema = exports.NodeConfigSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const tasks_1 = require("../../uiNodes/tasks");
const v4_1 = require("zod/v4");
exports.NodeConfigSchema = tasks_1.TapeBuilderTaskSchema;
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal('intermediateTape'),
    configuration: exports.NodeConfigSchema,
});
exports.artifactType = 'intermediateTape';
//# sourceMappingURL=node.js.map